






































import Vue from 'vue'
import { SubTpl } from '@/mass/models/SubTpl'
import commonVuex from '@/common/vuex/common'
import massApis from '@/mass/apis'

export default Vue.extend({
  mixins: [commonVuex],
  components: {
  },
  data() {
    return {
      showDeletePop: false,
    }
  },
  props: {
    subCount: {
      type: Number,
    },
    tpl: {
      type: Object as () => SubTpl,
      required: true,
    },
  },
  computed: {
    testSubLink(): string {
      return `https://${this.account.domain}.weixin.drip.im/wx-web/form/sub/${this.tpl.tplId}?special=${this.account.domain}`
    },
  },
  methods: {
    startSend() {
      this.$emit('start-send')
    },
    confirmDelete() {
      massApis.deleteSubTpl({
        tplId: this.tpl.tplId,
      }).success(() => {
        this.$Message.success('模板已删除')
        this.$emit('deleted')
        this.showDeletePop = false
      }).failure(() => {
        this.$Message.error('删除失败')
        this.showDeletePop = false
      })
    },
  },
})
